import { ColInfo, SortingState } from '../../../data-models/table.typings';

export const colS: ColInfo[] = [
   {
      name: 'Chekker',
      key: 'chekker',
      width: 30,
      sort: null,
      search: null,
   },
   {
      name: 'Title',
      width: 150,
      key: 'title',
      sort: {
         state: SortingState.None,
      },
      search: {
         lastSearchBy: '',
      },
   },
   {
      name: 'Duration',
      width: 120,
      key: 'duration',
      sort: {
         state: SortingState.None
      },
      search: null,
   },
   {
      name: 'Date',
      width: 200,
      key: 'date',
      sort: {
         state: SortingState.None
      },
      search: null,
   },
   {
      name: 'Comment',
      width: 150,
      key: 'comment',
      sort: {
         state: SortingState.None
      },
      search: null,
   },
   {
      name: '',
      key: 'action',
      width: 150,
      sort: null,
      search: null,
   }
];




// WEBPACK FOOTER //
// ./src/app/main/myRecordings/tables/recordings.ts